// extracted by mini-css-extract-plugin
module.exports = {"container":"checkBox_container__PYPzF","input":"checkBox_input__2RGtu","label":"checkBox_label__16rrb","red":"checkBox_red__qXe42"};